import { mapEvaluateResponseToTextMode } from '@/features/text-mode/api'
import type { FlexiObservation } from '@/features/text-mode/api'
import type { TextModePatientInfo } from '@/features/text-mode/types/text-mode.types'
import type { Pinia } from 'pinia'
import { useDraftStore } from '@/features/text-mode/stores/draft.store'
import { useEvidenceStore } from '@/features/text-mode/stores/evidence.store'
import { useNoteStore } from '@/features/text-mode/stores/note.store'
import { usePatientStore } from '@/features/text-mode/stores/patient.store'
import { useQuestionStore } from '@/features/text-mode/stores/question.store'
import { useAlertStore } from '@/features/text-mode/stores/alert.store'

interface ApplyGuidedAssessmentArgs {
  observations: FlexiObservation[]
  patient: TextModePatientInfo
  comprehensive: boolean
  focusedAssessments: string[]
  conditions: string[]
  pinia?: Pinia
}

function resetGuidedEncounterState(pinia?: Pinia): void {
  useNoteStore(pinia).reset()
  useQuestionStore(pinia).reset()
  useEvidenceStore(pinia).reset()
  useDraftStore(pinia).fullReset()
  usePatientStore(pinia).reset()
  useAlertStore(pinia).reset()
}

export function applyGuidedAssessment({
  observations,
  patient,
  comprehensive,
  focusedAssessments,
  conditions,
  pinia,
}: ApplyGuidedAssessmentArgs): void {
  resetGuidedEncounterState(pinia)

  const mapped = mapEvaluateResponseToTextMode({
    observations,
    patient,
    questions: [],
    extractions: [],
    conditions,
    focusedAssessments,
    comprehensive,
  })

  usePatientStore(pinia).setPatient(mapped.patient)
  useNoteStore(pinia).setFocusedAssessments(mapped.focusedAssessments)
  useEvidenceStore(pinia).setEvidenceCategories(mapped.evidenceCategories)
}
